import { CalendarOutlined } from "@ant-design/icons";
export const generateCustomRanges = (t) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); 

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const last7DaysStart = new Date(today);
  last7DaysStart.setDate(today.getDate() - 6); 

  const last30DaysStart = new Date(today);
  last30DaysStart.setDate(today.getDate() - 29); 

  const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
  const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);

  // const thisYearStart = new Date(today.getFullYear(), 0, 1); 
  // const thisYearEnd = new Date(today.getFullYear(), 11, 31); 

  // const lastYearStart = new Date(today.getFullYear() - 1, 0, 1);
  // const lastYearEnd = new Date(today.getFullYear() - 1, 11, 31);

  // Helper to set end of day for a given date
  const setEndOfDay = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };

  return [
    {
      label: t("Today "),
      value: "today",
      startDate: today,
      endDate: setEndOfDay(today),
    },
    // {
    //   label: t("Yesterday "),
    //   value: "yesterday",
    //   startDate: yesterday,
    //   endDate: setEndOfDay(yesterday),
    // },
    {
      label: t("Last Week "), // Last 7 days, including today
      value: "lastWeek",
      startDate: last7DaysStart,
      endDate: setEndOfDay(today),
    },

    {
      label: t("This Month "),
      value: "month",
      startDate: thisMonthStart,
      endDate: setEndOfDay(thisMonthEnd),
    },
    {
      label: t("Last Month "),
      value: "lastMonth",
      startDate: lastMonthStart,
      endDate: setEndOfDay(lastMonthEnd),
    },
    // {
    //   label: t("This Year "),
    //   value: "year",
    //   startDate: thisYearStart,
    //   endDate: setEndOfDay(thisYearEnd),
    // },
    // {
    //   label: t("Last Year "),
    //   value: "lastYear",
    //   startDate: lastYearStart,
    //   endDate: setEndOfDay(lastYearEnd),
    // },
    {
      label: t("Custom "),
      value: "CustomDate",
      icon: <CalendarOutlined />,
      className: "text-info-custom",
      startDate: null, // Use null for custom selection, will be set by user
      endDate: null, // Use null for custom selection, will be set by user
    },
  ];
};
